/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelFormSelect64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelFormSelect64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 26C5 23.2386 7.23858 21 10 21H54C56.7614 21 59 23.2386 59 26V38C59 40.7614 56.7614 43 54 43H10C7.23858 43 5 40.7614 5 38V26ZM50.6465 29.6465L48 32.2929L45.3536 29.6465L44.6465 30.3536L48 33.7071L51.3536 30.3536L50.6465 29.6465ZM15 32H36V31H15V32Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelFormSelect64Icon.tags = [
  'dropdown',
  'select',
  'form',
  'choice',
  'list',
];

AddPanelFormSelect64Icon.category = '64x64 (Add panel)';

AddPanelFormSelect64Icon.iconSize = 64;
